import { render } from "./CometChatReceiverFileMessageBubble.vue?vue&type=template&id=7daba804&scoped=true"
import script from "./CometChatReceiverFileMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatReceiverFileMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatReceiverFileMessageBubble.vue?vue&type=style&index=0&id=7daba804&scoped=true&lang=css"
import "./CometChatReceiverFileMessageBubble.vue?vue&type=style&index=1&id=7daba804&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daba804"]])

export default __exports__